import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { LocalizedNameFields, TextInput, TextareaInput } from '@/components/inputs';
import { Text } from '@/components/typography';
import { addPrefixToDataParams } from '@/utils/string';
import { Button } from '@/components/buttons';
import { useForm } from '@formspree/react';
import CheckIcon from '@/assets/icons/heroIcons/CheckCircle.svg';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { required, email } from '@/utils/validators';
import { logEvent } from '@/analytics/events';
export const ContactForm = () => {
  const $ = _c(22);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["whistleblowing", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const [state, handleSubmitForm] = useForm("mrgnlgej");
  if (state.succeeded) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CheckIcon className="mx-auto h-16 w-16 text-blue-500" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t) {
      t2 = t("form.success.title");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <h2 className="mt-8 mb-3 text-3xl font-bold">{t2}</h2>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t) {
      t4 = t("form.success.text");
      $[6] = t;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t4) {
      t5 = <p>{t4}</p>;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== t3 || $[11] !== t5) {
      t6 = <div className="rounded-xl bg-white px-4 py-6 text-center lg:rounded-4xl lg:p-12">{t1}{t3}{t5}</div>;
      $[10] = t3;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t1;
  if ($[13] !== handleSubmitForm) {
    t1 = data => {
      logEvent("generate_lead", {
        action: "whistleblowing"
      });
      setTimeout(() => {
        const formData = new FormData();
        Object.entries(data).forEach(t2 => {
          const [key, value] = t2;
          if (key === "upload") {
            if (value) {
              for (let i = 0; i < value.length; i++) {
                formData.append("upload", value[i]);
              }
            }
          } else {
            formData.append(key, value);
          }
        });
        handleSubmitForm(formData);
      });
    };
    $[13] = handleSubmitForm;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      _subject: "Whistleblowing",
      _language: "cs"
    };
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== state.submitting || $[17] !== t) {
    t3 = t4 => {
      const {
        handleSubmit
      } = t4;
      return <form encType="multipart/form-data" method="post" onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "whistleblowing",
        testId: "whistleblowing",
        prefix: "form"
      })}><div className="mb-10 flex flex-col gap-8"><div className="flex flex-col gap-4"><p className="font-semibold">{t("form.categories.1")}</p><LocalizedNameFields nameField={{
              name: "name",
              label: t("form.fields.name")
            }} surnameField={{
              name: "surname",
              label: t("form.fields.surname")
            }} /><Field name="email" type="email" validate={email}>{fieldRenderProps => <TextInput {...fieldRenderProps} label={t("form.fields.email")} />}</Field></div><div className="flex flex-col gap-4"><p className="font-semibold">{t("form.categories.2")}</p><Field name="message" defaultValue="" validate={required}>{fieldRenderProps_0 => <TextareaInput {...fieldRenderProps_0} label={t("form.fields.message")} />}</Field><Field name="upload">{_temp}</Field></div></div><Text variant="p4" className="mb-6 text-center text-gray-600 lg:mb-10"><Trans t={t} i18nKey="form.conditions"><Link testId="informationMemorandum" analyticsParam="informationMemorandum" to={LINKS().informationMemorandum} /></Trans></Text><Button type="submit" analyticsParam="submitForm" testId="submitForm" variant="primary" align="center" size="lg" busy={state.submitting}>{t("core:forms.fields.submit")}</Button></form>;
    };
    $[16] = state.submitting;
    $[17] = t;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== t1 || $[20] !== t3) {
    t4 = <><div className="rounded-xl bg-white px-4 py-6 lg:rounded-4xl lg:p-12"><Form onSubmit={t1} initialValues={t2} encType="multipart/form-data">{t3}</Form></div></>;
    $[19] = t1;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
function _temp(t0) {
  const {
    input: t1
  } = t0;
  const {
    onChange,
    ...input
  } = t1;
  return <input {...input} value={undefined} type="file" multiple={true} id="upload" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*" onChange={t2 => {
    const {
      target
    } = t2;
    return onChange(target.files);
  }} className="input file:text-md p-[2px] placeholder-gray-400 file:mr-5 file:rounded-lg file:border-0 file:bg-blue-500 file:px-6 file:py-3 file:font-semibold file:text-white hover:file:cursor-pointer hover:file:bg-blue-600" />;
}